// import { setFiles } from "./actionCreators";
import axios from "axios";

export function callGroupRegistrationApi(formData: FormData){
  return axios({
    method: "POST",
    url: "/api/GroupRegistration/group-registration",
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData,
  });
}

export function getGroupRegistrationProgress(key: number){
  return axios({
      method: "GET",
      url: `/api/GroupRegistration/query-progress/${key}`
  });
}